export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/photoshop_editing.e330a89.svg";